import React, { useRef, useState } from 'react';
import Button from '../Button/Button';
import './ContactForm.scss';
import emailjs from '@emailjs/browser';

function ContactForm() {
    const form = useRef();
    const [errors, setErrors] = useState({});
    const [emailResponse, setEmailResponse] = useState({});
    const [phoneNumber, setPhoneNumber] = useState(''); // State to control the phone number input

    const validateForm = (formData) => {
        const newErrors = {};
        if (!formData.user_name.trim()) {
            newErrors.user_name = 'Name is required';
        }
        if (!formData.user_email.trim()) {
            newErrors.user_email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.user_email)) {
            newErrors.user_email = 'Invalid email format';
        }
        if (!phoneNumber.trim()) {
            newErrors.user_phone = 'Phone number is required';
        } else if (!/^\+?\d+$/.test(phoneNumber)) {
            newErrors.user_phone =
                'Phone number should only contain digits and an optional "+" at the beginning.';
        }
        if (!formData.message.trim()) {
            newErrors.message = 'Message is required';
        }
        return newErrors;
    };

    const handlePhoneChange = (event) => {
        const value = event.target.value;
        const validChars = /^\+?\d*$/; // Allows optional '+' at the start and then only digits
        if (validChars.test(value)) {
            setPhoneNumber(value);
        }
    };

    const sendEmail = (e) => {
        e.preventDefault();

        const formData = new FormData(form.current);
        const formDataObject = Object.fromEntries(formData.entries());
        formDataObject.user_phone = phoneNumber;

        const validationErrors = validateForm(formDataObject);

        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        emailjs
            .sendForm(
                process.env.REACT_APP_EMAILJS_SERVICE_ID,
                process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
                form.current,
                {
                    publicKey: process.env.REACT_APP_EMAILJS_PUBLIC_KEY,
                },
            )
            .then(
                (result) => {
                    if (result.status === 200) {
                        setEmailResponse({
                            status: 'success',
                            message:
                                'Thank you for contacting. Our team will be in touch!',
                        });
                    }
                    form.current.reset();
                    setPhoneNumber('');
                    setErrors({});
                },
                (_error) => {
                    setEmailResponse({
                        status: 'error',
                        message:
                            'An error occurred while sending the email. Please try again or use other contact methods.',
                    });
                },
            );
    };

    return (
        <section className="section contact-section">
            <div className="container">
                <h3 className="title contact-form-title">Get in touch</h3>
                <span>
                    Our team is looking forward to helping you on your upcoming
                    project. For further inquiries, please fill out following
                    form
                </span>
                <div className="section-content">
                    <form
                        className="contact-form"
                        ref={form}
                        onSubmit={sendEmail}
                        noValidate
                    >
                        {' '}
                        {/* Added noValidate */}
                        <div className="form-row">
                            <div className="form-input">
                                <label htmlFor="user_name">Name</label>
                                <input
                                    className={`text-input ${errors.user_name ? 'error' : ''}`}
                                    type={'text'}
                                    name="user_name"
                                    id="user_name"
                                    required
                                />
                                {errors.user_name && (
                                    <span className="error-message">
                                        {errors.user_name}
                                    </span>
                                )}
                            </div>
                            <div className="form-input">
                                <label htmlFor="user_email">Email</label>
                                <input
                                    className={`text-input ${errors.user_email ? 'error' : ''}`}
                                    type={'text'}
                                    name="user_email"
                                    id="user_email"
                                    required
                                />
                                {errors.user_email && (
                                    <span className="error-message">
                                        {errors.user_email}
                                    </span>
                                )}
                            </div>
                            <div className="form-input">
                                <label htmlFor="user_phone">Phone No.</label>
                                <input
                                    className={`text-input ${errors.user_phone ? 'error' : ''}`}
                                    type={'text'}
                                    name="user_phone"
                                    id="user_phone"
                                    required
                                    value={phoneNumber} // Control the input value with state
                                    onChange={handlePhoneChange} // Handle input changes
                                />
                                {errors.user_phone && (
                                    <span className="error-message">
                                        {errors.user_phone}
                                    </span>
                                )}
                            </div>
                        </div>
                        <div className="form-input textarea">
                            <label htmlFor="message">Your Message</label>
                            <textarea
                                rows={5}
                                className={`text-input ${errors.message ? 'error' : ''}`}
                                type={'text'}
                                name="message"
                                id="message"
                                required
                            ></textarea>
                            {errors.message && (
                                <span className="error-message">
                                    {errors.message}
                                </span>
                            )}
                        </div>
                        <div className="submit-button">
                            {emailResponse && (
                                <span
                                    className={
                                        emailResponse.status === 'success'
                                            ? 'success-message'
                                            : 'error-message'
                                    }
                                >
                                    {emailResponse.message}
                                </span>
                            )}
                            <Button type="submit">Submit</Button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default ContactForm;
